import * as Highcharts from "highcharts";
// chart with 2 lines

export const chartData = {
  credits: { enabled: false },
  title: { text: "" },
  yAxis: {
    min: 90,
    max: 100,
    title: {
      text: "Percentage"
    }
  },
  xAxis: [
    {
      categories: [
        "1Jul",
        "2Jul",
        "3Jul",
        "4Jul",
        "5Jul",
        "6Jul",
        "7Jul",
        "8Jul",
        "9Jul",
        "10Jul",
        "11Jul"
      ],
      crosshair: true
    }
  ],
  plotOptions: {
    series: {
      label: {
        connectorAllowed: false
      },
      pointStart: 90
    }
  },
  series: [
    {
      name: "Overall Temperature Adherance",
      data: [91, 92, 91, 95, 98, 93, 91, 97]
    }
  ]
};
